import { useCallback, useMemo } from 'react';
import { useCreateEditorThreadMutation } from 'src/store/services';
import {
  ArtifactCodeV3,
  ArtifactMarkdownV3,
  CreateEditorThreadRequest,
  ArtifactType,
} from 'src/types';
import { useSession } from '../useSession';
import { useErrorToast } from '../toastHooks';
import { useCurrentConversation } from '../conversationHooks';
import { convertTaskHashToTitle } from 'src/utils';
import { DEFAULT_THREAD_TITLE } from 'src/constants';

const DEFAULT_INDEX = 1;

export const useCreateEditorThread = () => {
  const { currentConversation } = useCurrentConversation();
  const { onShowErrorToast } = useErrorToast();

  const { appUser } = useSession();
  const { user_id } = appUser;

  const [createEditorThread, { isLoading: isCreateEditorThreadLoading }] =
    useCreateEditorThreadMutation();

  const onCreateEditorThread = useCallback(
    async ({
      artifactContent,
      artifactType,
    }: {
      artifactContent?: ArtifactMarkdownV3 | ArtifactCodeV3;
      artifactType: ArtifactType;
    }) => {
      const conversationTitle = currentConversation?.conversation_hash?.replace(
        '#',
        '',
      );

      const thread_title = artifactContent?.title
        ? artifactContent?.title
        : conversationTitle
          ? convertTaskHashToTitle(conversationTitle)
          : DEFAULT_THREAD_TITLE;

      const body: CreateEditorThreadRequest = {
        user_id,
        thread: {
          artifact: {
            currentIndex: DEFAULT_INDEX,
            contents: artifactContent
              ? [
                  {
                    ...artifactContent,
                    title: thread_title,
                    // TODO(olha): WIP Editor remove hen BE fix POST response
                    index: DEFAULT_INDEX,
                  },
                ]
              : [],
          },
          thread_type: artifactType,
          thread_title,
        },
      };

      try {
        const thread = await createEditorThread(body).unwrap();

        return thread;
      } catch (error) {
        onShowErrorToast();
      }
    },
    [user_id, currentConversation, createEditorThread, onShowErrorToast],
  );

  return useMemo(
    () => ({
      onCreateEditorThread,
      isCreateEditorThreadLoading,
    }),
    [onCreateEditorThread, isCreateEditorThreadLoading],
  );
};
